// extracted by mini-css-extract-plugin
export default {"Errorpage":"thankyou_Errorpage__M-zUa","imgText":"thankyou_imgText__aILsw","images":"thankyou_images__TQa0o","TextHead":"thankyou_TextHead__vd4oc","button":"thankyou_button__aOMOA"};